import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import PropTypes from 'prop-types';
import { selector as configSelector, actions as configActions } from '~/config'

import i18n, { getLanguages, getDefaultLanguage } from '~/i18n'
import entities from "~/entities";
import {find, filter} from "lodash";
const __ = i18n.t.bind(i18n);


export default kea({
  path : () => ['root', 'language'],

  actions : ({ constants }) => ({
    changeLanguage: language => ({ language }),
  }),

  reducers : ({ actions, constants }) => ({
    menu: [[], PropTypes.array, {
    }]
  }),

  selectors : ({ constants, selectors }) => ({
    activeShop: [
      () => [
        configSelector,
        entities.selectors.shops
      ],
      (config, shops) => {
        const { activeShop } = config;
        if(activeShop && shops) {
          const shop = find(shops, {url: activeShop});

          if(shop) {
            return shop;
          }
        }
        return null;
      },
      PropTypes.object
    ],
    languages: [
      () => [
        selectors.activeShop
      ], (activeShop) => {
        return filter(getLanguages(), (lang) => {
          return activeShop && activeShop.checkout_settings.languages.indexOf(lang.value) > -1
        });
      }
    ],
    visible: [
      () => [
        selectors.activeShop,
        selectors.languages,
      ],
      (activeShop, languages) => {
        return activeShop && languages && languages.length > 1;
      },
      PropTypes.bool
    ],
    language: [
      () => [
        configSelector,
        selectors.languages
      ], (config, languages) => {
        return find(languages, {value: config.language}) || getDefaultLanguage();
      }
    ],
  }),
  takeLatest: ({ actions, workers}) => ({
    [actions.changeLanguage]: workers.changeLanguage
  }),
  workers: {
    changeLanguage: function * (action) {
      const { language } = action.payload;
      yield put(configActions.setLanguage(language));
    }
  }
})
